import { EnrollmentFormDenormalized } from '@dadohr/shared/domainTypes/enrollmentForms';
import { IRecipient } from '@dadohr/shared/domainTypes/mail';
import { IOrganizationDenormalized } from '@dadohr/shared/domainTypes/org';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { OrgLogo } from '../../components/OrgLogo';
import {
  Help,
  HelpEnrollmentForm
} from '../features/Experience/components/Help';
import { useStandaloneAppContext } from '../hooks/useStandaloneAppContext';

export const TOP_NAV = {
  COLORS: {
    light: '#ffffff',
    lightDimmed: '#ffffffde',
    dark: '#111111'
  }
};

const TopNavBar = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  min-height: ${(p) => p.theme.spacing(7)}px;
  background-color: ${TOP_NAV.COLORS.light};

  @media (min-width: 600px) {
    padding: ${(p) => `0 ${p.theme.spacing(3)}px`};
  }
`;

const TopNavBarSection = styled('div')<{
  flex: number;
  align?: string;
  minWidth?: number;
}>`
  flex: ${(p) => p.flex};
  padding: ${(p) => `${p.theme.spacing(1)}px ${p.theme.spacing(3)}px`};
  text-align: ${(p) => p.align || 'left'};
  ${(p) => (p.minWidth ? `min-width: ${p.minWidth}px;` : '')}
`;

export const SIDE_NAV_WIDTH = 144;
export type TopNavProps = {
  accessToken: string;
  title: string;
  org: IOrganizationDenormalized;
  mail: IRecipient | undefined;
};

export const TopNav = ({ d }: { d: TopNavProps }) => {
  const { routing } = useStandaloneAppContext();
  return (
    <TopNavBar>
      <TopNavBarSection flex={0}>
        {routing.toOverview.href ? (
          <Link to={routing?.toOverview.href(d.accessToken)}>
            <OrgLogo d={d.org} />
          </Link>
        ) : (
          <OrgLogo d={d.org} />
        )}
      </TopNavBarSection>
      <TopNavBarSection flex={1} align="right">
        <Help d={d} />
      </TopNavBarSection>
    </TopNavBar>
  );
};

export const TopNavEnrollmentForm = ({
  d
}: {
  d: EnrollmentFormDenormalized;
}) => {
  return (
    <TopNavBar>
      <TopNavBarSection flex={0}>
        <OrgLogo d={d.org} />
      </TopNavBarSection>
      <TopNavBarSection flex={1} align="right">
        <HelpEnrollmentForm d={d} />
      </TopNavBarSection>
    </TopNavBar>
  );
};
